<template>
  <div
    :class="[
      'sidebar-popover-mian',
      isWhole == true ? '' : 'sidebar-popover-mian2',
    ]"
  >
    <div
      v-for="(itemB, indexB) in item.children"
      :key="indexB"
      class="popover-ul-mian"
    >
      <!--多级的-->
      <ul class="sidebar-popover-ul">
        <div
          :class="[
            'sidebar-popover-title',
            indexB == 0 ? 'popover-title-margin' : '',
          ]"
        >
          {{
            itemB.meta && itemB.meta.title && itemB.meta.title != ""
              ? itemB.meta.title
              : "-"
          }}
        </div>
        <div
          v-if="
            !(
              itemB.children &&
              Array.isArray(itemB.children) &&
              itemB.children.length > 0
            )
          "
          :class="[
            'sidebar-popover-li',
            activeMenu.indexOf('-' + itemB.id + '-') > -1
              ? 'popover-li-active'
              : '',
          ]"
          @click.stop="
            popoverClick([basePath, itemB.path], itemB.children, itemB)
          "
        >
          {{ itemB.meta && itemB.meta.title }}
        </div>
        <template v-else v-for="(itemC, indexC) in itemB.children">
          <template
            v-if="
              itemC.children &&
              Array.isArray(itemC.children) &&
              itemC.children.length > 0
            "
          >
            <el-submenu
              :key="indexC"
              :class="[
                'sidebar-popover-li',
                'sidebar-popover-li2',
                activeMenu.indexOf('-' + itemC.id + '-') > -1
                  ? 'popover-li-active'
                  : '',
              ]"
              :popper-append-to-body="false"
              :index="itemC.id.toString()"
            >
              <template slot="title">
                <span>
                  {{ itemC.meta && itemC.meta.title && itemC.meta.title }}</span
                >
              </template>
              <!--递归组件，把遍历的值传回子组件，完成递归调用-->

              <SidebarPopover
                :basePath="itemC.path"
                :item="itemC"
                :activeId="activeId"
                @close="closePopover"
              ></SidebarPopover>
            </el-submenu>
          </template>

          <template v-else>
            <div
              :key="indexC"
              :class="[
                'sidebar-popover-li',
                activeMenu.indexOf('-' + itemC.id + '-') > -1
                  ? 'popover-li-active'
                  : '',
              ]"
              @click.stop="
                popoverClick(
                  [basePath, itemB.path, itemC.path],
                  indexC.children,
                  itemC
                )
              "
            >
              {{ itemC.meta && itemC.meta.title }}
            </div>
          </template>
        </template>
      </ul>
      <!--多级的-->
    </div>
  </div>
</template>


<script>
export default {
  name: "SidebarPopover",
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
    isWhole: {
      type: Boolean,
      default: false,
    },
    activeId: {
      type: String,
      required: "#",
    },
  },

  data() {
    return {
      companyData: {
        data: {},
      },
    };
  },
  components: {},
  computed: {
    activeMenu() {
      return this.activeId && this.activeId != "" ? this.activeId : "#";
    },
  },
  created() {
    this.companyData.data = JSON.parse(localStorage.getItem("companyInfo"));
  },
  methods: {
    //主动关闭
    closePopover() {
      this.$emit("close");
    }, 
    popoverClick(pathArr, children, item) {
      let val = JSON.parse(JSON.stringify(item));
      if (val.oldData) {
        val = val.oldData;
      }
      if (pathArr && pathArr.length > 0) {
        localStorage.setItem(
          "Permission",
          JSON.stringify(val.childList.length ? val.childList : [val])
        );
        this.$emit("close");
        if (val.route === "/processManager/peopleOnline") {
          window.open(localStorage.getItem("companyMapUrl3"), "_blank");
          return;
        }
        this.$store.commit("add_tabs", {
          route: val.route,
          name: val.menuName,
        });
        this.$router.push(val.route);
        this.indexVal = val.id;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>

 
<style lang="scss" >
$primary: #00baff;
.sidebar-popover-mian {
  width: 100%;
  display: block;
  padding-bottom: 10px;
  overflow-y: auto;

  .sidebar-popover-ul {
    list-style: none;
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    .sidebar-popover-title {
      width: 100%;
      border-left: $primary solid 3px;
      font-size: 14px;
      height: 16px;
      line-height: 16px;
      color: #313131;
      margin: 25px 5px 0px 10px;
      font-weight: bold;
      display: block;
      padding-left: 10px;
      text-align: left;
    }

    .popover-title-margin {
      margin: 5px 5px 0px 10px !important;
    }
  }

  .popover-ul-mian {
    width: 100%;
    display: block;
  }

  .sidebar-popover-li {
    position: relative;
    cursor: pointer;
    width: calc(50% - 20px);
    padding: 5px 10px;
    background: #e4eaf0;
    border-radius: 3px;
    font-size: 12px;
    color: #313131;
    text-align: center;
    margin: 10px 10px 0 10px;
    line-height: 20px !important ;

    > .el-submenu__title {
      text-align: center;
      background: none !important;
      display: flex;
      justify-content: center;
      align-items: center;
      height: auto !important;
      padding: 0 !important;
      > span {
        font-size: 12px;
        color: #313131;
        text-align: center;
        line-height: 20px !important ;
        max-width: 100%;
        white-space: normal;
      }

      > .el-submenu__icon-arrow {
        position: relative !important;
        top: 0 !important;
        right: 0 !important;
        margin-top: 0 !important;
        margin-left: 5px !important;
        color: #313131;
      }
    }
  }
  .sidebar-popover-li2 {
    width: calc(100% - 20px);
  }

  .popover-li-active {
    background: $primary;
    color: #fff;

    > .el-submenu__title {
      > span {
        color: #fff;
      }

      > .el-submenu__icon-arrow {
        color: #fff;
      }
    }
  }
}

.sidebar-popover-mian2 {
  max-height: 80vh;
}
</style> 